//give us something to mock in tests
export default (url) => (window.location.href = url);
